export default class QuestionnaireAnswer {
    constructor(raw = {}) {
        this.answer = raw.answer;
        this.valid = raw.valid;
    }

}
